import type { IconDef } from '../types';

export const rightArrow: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M14.376 3.45019C13.9858 3.84035 13.9858 4.47061 14.376 4.86077L20.5986 11.0834L1.00042 11.0834C0.450187 11.0834 -4.13791e-07 11.5336 -3.8974e-07 12.0838C-3.65689e-07 12.634 0.450187 13.0842 1.00042 13.0842L20.5986 13.0842L14.376 19.2968C13.9858 19.687 13.9858 20.3172 14.376 20.7074C14.7662 21.0975 15.3964 21.0975 15.7866 20.7074L23.7099 12.7841C23.91 12.584 24 12.3339 24 12.0738C24 11.8137 23.9 11.5636 23.7099 11.3635L15.7866 3.44018C15.3964 3.05002 14.7662 3.05002 14.376 3.44018L14.376 3.45019Z',
    },
  ],
};
